import React from 'react';
type SectionLabelProps = {
  number?: string;
  children: React.ReactNode;
  tone?: 'ink' | 'light';
};
export function SectionLabel({
  children,
  tone = 'ink'
}: SectionLabelProps) {
  const labelColor = tone === 'ink' ? 'text-ink' : 'text-warm';
  return <p className="flex items-center gap-3 font-display text-[13px] uppercase tracking-[0.24em]" data-id="element-217" data-mp="2ycq29rirrv3j">
      <span aria-hidden="true" className={tone === 'ink' ? 'h-px w-8 bg-steel-300' : 'h-px w-8 bg-steel'} data-id="element-218" data-mp="33bt8hfahk7d3" />
      <span className={labelColor} data-id="element-219" data-mp="3r1nizq7c1ju6">{children}</span>
    </p>;
}